import { Modal, message } from 'antd';

const asyncErrorHandler = (error: any) => {
  // @ts-ignore
  if (window.activeVersionModal) {
    return;
  }

  const isInvalidVersionError = error?.response?.status === 400 && error?.response?.data?.message === 'invalid_api_version';

  if (isInvalidVersionError) {
    // @ts-ignore
    window.activeVersionModal = true;
    const modal = Modal.info({});
    modal.update({
      title: 'An update is available',
      okText: 'Refresh',
      cancelText: 'Close',
      content: <div>You must refresh the page to get the latest version and be able to proceed.</div>,
      closable: true,
      onOk: () => {
        // @ts-ignore
        window.activeVersionModal = false;
        window.location.reload();
      },
      onCancel: () => modal.destroy(),
    });
  } else {
    if (error?.response?.data?.message === 'existing_subtasks') {
      message.error('You must complete all subtasks before complete this one.');
      return;
    }

    if (Array.isArray(error?.errorFields)) {
      const messageError =
        error.errorFields.length === 1 && error.errorFields[0].errors.length === 1
          ? error.errorFields[0].errors[0]
          : 'Some fields need your attention. Please review and correct the errors.';

      message.error(messageError);
      return;
    }

    const errors = error?.response?.data?.errors;
    const keys = Object.keys(errors ?? {});
    if (keys.length > 0) {
      const values = keys.map((key) => errors[key]);
      message.error(values[0]);
    } else {
      message.error(error?.response?.data?.message ?? error.message ?? 'Something went wrong!');
    }
  }
};

export default asyncErrorHandler;
